module.exports = __webpack_public_path__ + "static/media/computer.d1cff8ae.svg";